module.exports = __webpack_public_path__ + "img/2f1ee96.png";